var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E9EFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8998 32.0008C21.8998 37.5736 26.427 42.1008 31.9998 42.1008C32.4726 42.1008 32.8498 41.7236 32.8498 41.2508C32.8498 40.7779 32.4726 40.4008 31.9998 40.4008C27.3726 40.4008 23.5998 36.6279 23.5998 32.0008C23.5998 27.3736 27.3726 23.6008 31.9998 23.6008C36.627 23.6008 40.3998 27.3736 40.3998 32.0008C40.3998 32.4736 40.777 32.8508 41.2498 32.8508C41.7226 32.8508 42.0998 32.4736 42.0998 32.0008C42.0998 26.4279 37.5726 21.9008 31.9998 21.9008C26.427 21.9008 21.8998 26.4279 21.8998 32.0008Z",
    fill: "#5335E9",
    stroke: "#5335E9",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.145e93e0b638207e4f19232876c5a4fb.svg";
export { ForwardRef as ReactComponent };